import { createContext } from 'react';
import { TimeMs } from '../timeline/types';

export type PlaybackContextValue = {
  isPlaying: boolean;
  /** Auto-resumes the AudioContext (consumes the user gesture) before starting playback. */
  play: () => Promise<void>;
  pause: () => void;
  toggle: () => Promise<void>;
  /** Sets the playhead time. Does not affect isPlaying. */
  seek: (t: TimeMs) => void;
  /** 0..1 master volume for audio clips. */
  volume: number;
  setVolume: (v: number) => void;
  muted: boolean;
  setMuted: (m: boolean) => void;
};

export const PlaybackContext = createContext<PlaybackContextValue | null>(null);
